import { z } from 'zod';

const INTERVAL_DAYS: Record<string, number> = {
  daily: 1,
  weekly: 7,
  monthly: 30,
  quarterly: 90,
  semiannual: 180,
  yearly: 365,
};

const intervalDays = (interval: string): number => INTERVAL_DAYS[interval] ?? 0;

export const offerSchema = (categoryType: string, t: (key: string, params?: any) => string) =>
  z
    .object({
      name: z.string().min(1, t('common:required_field')),
      price: z.coerce.number().min(1, t('common:required_field')),
      currency: z.string(),
      payment_type: z.string().min(1, t('common:required_field')),
      recurring_interval: z.string().nullish(),
      trial_enabled: z.boolean().optional(),
      trial_mode: z.string().nullish(),
      trial_price: z.coerce.number().nullish(),
      trial_interval: z.string().nullish(),
      is_affiliate_enabled: z.boolean(),
      affiliate_commission_cycles: z.number().int().min(1).max(12).nullable().optional(),
      payment_methods: z.array(z.string()),
      sku: z.string().optional(),
      is_active: z.boolean().optional(),
    })
    .superRefine((data, ctx) => {
      // O mínimo por moeda é configurado no admin e validado pela API — o erro volta no toast.
      if (
        data.payment_type === 'recurring' &&
        (!data.recurring_interval || data.recurring_interval.trim() === '')
      ) {
        ctx.addIssue({
          path: ['recurring_interval'],
          code: z.ZodIssueCode.custom,
          message: t('common:required_field'),
        });
      }

      if (
        data.payment_type === 'recurring' &&
        data.payment_methods.length === 0
      ) {
        ctx.addIssue({
          path: ['payment_methods'],
          code: z.ZodIssueCode.custom,
          message: t('common:required_field'),
        });
      }

      if (
        data.payment_type === 'recurring' &&
        data.trial_enabled
      ) {
        if (!data.trial_mode || data.trial_mode.trim() === '') {
          ctx.addIssue({
            path: ['trial_mode'],
            code: z.ZodIssueCode.custom,
            message: t('common:required_field'),
          });
        }

        if (!data.trial_interval || data.trial_interval.trim() === '') {
          ctx.addIssue({
            path: ['trial_interval'],
            code: z.ZodIssueCode.custom,
            message: t('common:required_field'),
          });
        }

        if (
          data.trial_interval &&
          data.recurring_interval &&
          intervalDays(data.trial_interval) >= intervalDays(data.recurring_interval)
        ) {
          ctx.addIssue({
            path: ['trial_interval'],
            code: z.ZodIssueCode.custom,
            message: t('common:trial_free_longer_than_interval'),
          });
        }

        if (data.trial_mode === 'promotional') {
          if (!data.trial_price || data.trial_price < 1) {
            ctx.addIssue({
              path: ['trial_price'],
              code: z.ZodIssueCode.custom,
              message: t('common:required_field'),
            });
          } else if (data.trial_price >= data.price) {
            ctx.addIssue({
              path: ['trial_price'],
              code: z.ZodIssueCode.custom,
              message: t('common:trial_price_lt_offer'),
            });
          }
        }
      }

      if (
        categoryType === 'pharmaceutical' &&
        (!data.sku || data.sku.trim() === '')
      ) {
        ctx.addIssue({
          path: ['sku'],
          code: z.ZodIssueCode.custom,
          message: t('common:required_field'),
        });
      }
    });
